import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { Timestamp } from 'firebase/firestore';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import DeleteIcon from './Icons/DeleteIcon';
import EditIcon from './Icons/EditIcon';
import TermsTextArea from './TermsTextArea';

const FormTable = ({
  companyName,
  companyTRN,
  loading,
  setLoading,
  user,
  newInvoice,
  setCompanyNameError,
  setCompanyTRNError,
  quotation,
  setQuotationError,
  address,
  setAddressError,
}) => {
  const [items, setItems] = useState([]);
  const [description, setDescription] = useState('');
  const [quantity, setQuantity] = useState('');
  const [rate, setRate] = useState('');
  const [paymentCredits, setPaymentCredits] = useState(0);
  const [billerName, setBillerName] = useState('');
  const [billerNameError, setBillerNameError] = useState('');
  const [terms, setTerms] = useState('');

  const [descriptionError, setDescriptionError] = useState('');
  const [quantityError, setQuantityError] = useState('');
  const [rateError, setRateError] = useState('');
  const [termsError, setTermsError] = useState('');

  const handleAddItem = () => {
    // Reset all errors
    setDescriptionError('');
    setQuantityError('');
    setRateError('');

    // Validate fields
    validateField(description, 'description', 'Enter name of Item');
    validateField(quantity, 'quantity', 'Enter Quantity');
    validateField(rate, 'rate', 'Enter Rate');

    if (error) {
      return;
    }

    const newItem = {
      description,
      quantity,
      rate,
      amount: quantity * rate,
    };

    setItems([...items, newItem]);
    setDescription('');
    setQuantity('');
    setRate('');
  };
  const handleDeleteItem = (index) => {
    const updatedItems = [...items];
    updatedItems.splice(index, 1);
    setItems(updatedItems);
  };

  const calculateSubtotal = () => {
    return items.reduce((total, item) => total + item.amount, 0);
  };

  const calculateVAT = () => {
    return (calculateSubtotal() * 0.05).toFixed(2);
  };

  const calculateInvoiceTotal = () => {
    const amount = (calculateSubtotal() + parseFloat(calculateVAT())).toFixed(
      2
    );
    return amount.toLocaleString('en-AE');
  };
  const balanceDue = () => {
    const amount = (
      calculateSubtotal() +
      parseFloat(calculateVAT()) -
      paymentCredits
    ).toFixed(2);
    return amount.toLocaleString('en-AE');
  };

  //field validation and error logic
  let error = false;

  const validateField = (value, fieldName, errorMessage) => {
    if (!value) {
      error = true;
      setError(fieldName, errorMessage);
    } else {
      setError(fieldName, '');
    }
  };

  const setError = (fieldName, errorMessage) => {
    switch (fieldName) {
      case 'quotation':
        setQuotationError(errorMessage);
        break;
      case 'companyName':
        setCompanyNameError(errorMessage);
        break;
      case 'address':
        setAddressError(errorMessage);
        break;
      case 'companyTRN':
        setCompanyTRNError(errorMessage);
        break;
      case 'billerName':
        setBillerNameError(errorMessage);
        break;
      case 'description':
        setDescriptionError(errorMessage);
        break;
      case 'quantity':
        setQuantityError(errorMessage);
        break;
      case 'rate':
        setRateError(errorMessage);
        break;
      case 'terms':
        setTermsError(errorMessage);
        break;
      default:
        break;
    }
  };
  const handleSaveData = async () => {
    // Reset all errors
    setQuotationError('');
    setCompanyNameError('');
    setAddressError('');
    setCompanyTRNError('');
    setBillerNameError('');
    setTermsError('');
    // setDescriptionError('');
    // setQuantityError('');
    // setRateError('');

    // Validate fields
    validateField(quotation, 'quotation', 'Enter Quot');
    validateField(companyName, 'companyName', 'Enter company name');
    validateField(address, 'address', 'Enter address');
    validateField(companyTRN, 'companyTRN', 'Enter company TRN');
    validateField(billerName, 'billerName', 'This field cannot be empty.');
    validateField(terms, 'terms', 'Add terms and condition.');

    if (items.length < 1) {
      validateField(null, 'description', 'Add atleast one item to list');
      validateField(null, 'quantity', 'Add atleast one item to list');
      validateField(null, 'rate', 'Add atleast one item to list');
    } else {
      if (descriptionError && quantityError && rateError) {
      } else if (!descriptionError && !quantityError && !rateError) {
      } else {
        validateField(null, 'description', 'Fill this field or remove it.');
        validateField(null, 'quantity', 'Fill this field or remove it.');
        validateField(null, 'rate', 'Fill this field or remove it.');
      }
    }
    if (terms.endsWith('\n')) {
      setTermsError('Remove Empty line.');
      return;
    }
    if (items.some((item) => item.editMode === true)) {
      alert('Please close all the open fields.');
      return;
    }

    if (error) {
      return;
    }
    setDescriptionError('');
    setQuantityError('');
    setRateError('');

    setLoading(true);
    // alert('saving');
    const itemsToSend = {
      items: [...items],
      createdBy: user.email,
      createdAt: new Date().toISOString(),
      billerName,
      timestamp: Timestamp.fromDate(new Date()),
      quotation,
      billingDetails: {
        billTo: companyName,
        TRN: companyTRN,
        companyAddress: address,
      },
      billCalculation: {
        VAT: calculateVAT(),
        invoiceTotal: calculateInvoiceTotal(),
        credits: paymentCredits,
        balanceDue: balanceDue(),
      },
      termsAndConditions: terms,
    };
    console.log('itemsToSend', itemsToSend);
    try {
      await setDoc(doc(db, 'bills', uuidv4()), itemsToSend);
      alert('Data saved to db');
      window.location.reload();
    } catch (e) {
      console.log('fb up err', e);
      alert('Something went wrong, while saving');
    }
    setLoading(false);
  };
  const handlePrint = () => {
    // Logic to print the bill on Indian A4 size paper
    if (items.some((item) => item.editMode === true)) {
      alert('Please close all the open fields before printing.');
      return;
    }
    if (terms.endsWith('\n')) {
      setTermsError('Remove Empty line.');
      return;
    }
    window.print();
  };
  const handleEditItem = (index) => {
    // Create a copy of the items array
    const updatedItems = [...items];

    // Toggle the editMode property of the clicked item
    updatedItems[index] = {
      ...updatedItems[index],
      editMode: !updatedItems[index].editMode,
    };

    // Update the state with the new array of items
    setItems(updatedItems);
  };
  // Initialize the error states
  const [descriptionEditError, setDescriptionEditError] = useState('');
  const [quantityEditError, setQuantityEditError] = useState('');
  const [rateEditError, setRateEditError] = useState('');

  // Reset the error states
  const resetEditErrorStates = () => {
    setDescriptionEditError('');
    setQuantityEditError('');
    setRateEditError('');
  };

  const handleSaveItem = (index) => {
    // Retrieve the item based on the index
    const selectedItem = items[index];

    // Reset the error states
    resetEditErrorStates();

    // Validate the updated values
    let isValid = true;

    if (selectedItem.description.trim() === '') {
      setDescriptionEditError('Description is required');
      isValid = false;
    }

    if (selectedItem.quantity <= 0) {
      setQuantityEditError('Quantity must be greater than zero');
      isValid = false;
    }

    if (selectedItem.rate <= 0) {
      setRateEditError('Rate must be greater than zero');
      isValid = false;
    }

    if (isValid) {
      // Create a new array with the updated item
      const updatedItems = [...items];
      updatedItems[index] = {
        ...selectedItem,
        amount: selectedItem.quantity * selectedItem.rate, // Recalculate the amount
        editMode: false, // Set the edit mode to false after saving
      };

      // Update the state with the new array of items
      setItems(updatedItems);
    } else {
      // Handle validation errors
      // You can display an error message or perform any other action here
    }
  };

  const handleItemInputChange = (index, field, value) => {
    // Create a new array with the updated item
    const updatedItems = [...items];
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: value,
    };

    // Update the state with the new array of items
    setItems(updatedItems);
  };

  return (
    <div>
      <table className="border-collapse border  border-b-0 border-l-0 border-r-0 border-black mt-4  mx-3 print:mx-0">
        <colgroup>
          <col style={{ width: '60%' }} />
          <col style={{ width: '7%' }} />
          <col style={{ width: '7%' }} />
          <col style={{ width: '15%' }} />
        </colgroup>
        <thead>
          <tr>
            <td
              colSpan="4"
              className="border border-black py-1 text-sm"
              align="center"
            >
              Project
            </td>
          </tr>
          <tr>
            <td
              colSpan="4"
              className="border border-black py-1 text-sm"
              align="center"
            >
              <span className="ml-1 hidden print:block">{billerName}</span>
              <input
                type="text"
                value={billerName}
                onChange={(e) => setBillerName(e.target.value)}
                className="border border-gray-300 px-2 py-1 print:hidden ml-1"
                placeholder="Biller Name"
              />
              {billerNameError && (
                <p className="text-xs text-red-400">{billerNameError}</p>
              )}
            </td>
          </tr>
          <tr>
            <th className="border border-black bg-gray-200 print:bg-gray-200  px-4 py-2">
              Description
            </th>
            <th className="border border-black bg-gray-200 print:bg-gray-200  px-4 py-2">
              Quantity
            </th>
            <th className="border border-black bg-gray-200 print:bg-gray-200  px-4 py-2">
              Rate
            </th>
            <th className="border border-black bg-gray-200 print:bg-gray-200  px-4 py-2">
              Amount
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="print:hidden border-b border-black">
            <td className=" px-2 py-0 border-l border-black " align="left">
              <div className="print:hidden my-1  ">
                <input
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="border border-gray-300 px-2 py-1 w-full"
                  placeholder="Item name here"
                />
                {descriptionError && (
                  <p className="text-rose-600 animate__animated animate__fadeIn text-xs ">
                    {descriptionError}
                  </p>
                )}
              </div>
            </td>
            <td className=" px-2 py-0 border-l border-black " align="right">
              <div className="print:hidden my-1">
                <input
                  type="number"
                  onKeyDown={(event) => {
                    if (
                      event.key === 'e' ||
                      event.key === 'E' ||
                      event.key === '-'
                    ) {
                      event.preventDefault();
                    }
                  }}
                  min={1}
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  className="border border-gray-300 px-2 py-1"
                  placeholder="quantity"
                />
                {quantityError && (
                  <p className="text-rose-600 animate__animated animate__fadeIn text-xs ">
                    {quantityError}
                  </p>
                )}
              </div>
            </td>
            <td className=" px-2 py-0 border-l border-black " align="right">
              <div className="print:hidden my-1">
                <input
                  type="number"
                  onKeyDown={(event) => {
                    if (
                      event.key === 'e' ||
                      event.key === 'E' ||
                      event.key === '-'
                    ) {
                      event.preventDefault();
                    }
                  }}
                  min={1}
                  value={rate}
                  onChange={(e) => setRate(e.target.value)}
                  className="border border-gray-300 px-2 py-1"
                  placeholder="rate"
                />
                {rateError && (
                  <p className="text-rose-600 animate__animated animate__fadeIn text-xs ">
                    {rateError}
                  </p>
                )}
              </div>
            </td>
            <td align="center" colSpan="2" className="border-x border-black">
              <button
                onClick={handleAddItem}
                className="bg-blue-500 text-white px-2 py-1 mr-2 print:hidden"
              >
                Add Item
              </button>
            </td>
          </tr>
          {items.map((item, index) => (
            <tr
              key={index}
              className="last:border-b border-black animate__animated animate__fadeIn"
              height={items.length - 1 === index ? '100px' : ''}
              valign="top"
            >
              {item.editMode ? (
                <>
                  <td className="px-2 py-0 border-l border-black " align="left">
                    <input
                      type="text"
                      value={item.description}
                      onChange={(e) =>
                        handleItemInputChange(
                          index,
                          'description',
                          e.target.value
                        )
                      }
                      className="border border-gray-300 px-2 py-1 w-full"
                      placeholder="Item name here"
                    />
                    {descriptionEditError && (
                      <p className="text-rose-600 animate__animated animate__fadeIn text-xs font-normal">
                        {descriptionEditError}
                      </p>
                    )}
                  </td>
                  <td
                    className="px-2 py-0 border-l border-black "
                    align="right"
                  >
                    <input
                      type="number"
                      onKeyDown={(event) => {
                        if (
                          event.key === 'e' ||
                          event.key === 'E' ||
                          event.key === '-'
                        ) {
                          event.preventDefault();
                        }
                      }}
                      min={1}
                      value={item.quantity}
                      onChange={(e) =>
                        handleItemInputChange(index, 'quantity', e.target.value)
                      }
                      className="border border-gray-300 px-2 py-1"
                      placeholder="quantity"
                    />
                    {quantityEditError && (
                      <p className="text-rose-600 animate__animated animate__fadeIn text-xs font-normal">
                        {quantityEditError}
                      </p>
                    )}
                  </td>
                  <td
                    className="px-2 py-0 border-l border-black "
                    align="right"
                  >
                    <input
                      type="number"
                      onKeyDown={(event) => {
                        if (
                          event.key === 'e' ||
                          event.key === 'E' ||
                          event.key === '-'
                        ) {
                          event.preventDefault();
                        }
                      }}
                      min={1}
                      value={item.rate}
                      onChange={(e) =>
                        handleItemInputChange(index, 'rate', e.target.value)
                      }
                      className="border border-gray-300 px-2 py-1"
                      placeholder="rate"
                    />
                    {rateEditError && (
                      <p className="text-rose-600 animate__animated animate__fadeIn text-xs font-normal">
                        {rateEditError}
                      </p>
                    )}
                  </td>
                  <td
                    className="px-2 py-0 border-x border-black "
                    align="right"
                    valign=""
                  >
                    <button
                      onClick={() => handleSaveItem(index)}
                      className="text-white bg-blue-500 px-2 font-light rounded-lg print:hidden ml-4 mt-1 flex items-center"
                    >
                      Save
                    </button>
                    {/* <button
                      onClick={() => handleEditItem(index)}
                      className="text-white bg-rose-500 px-2 font-light rounded-lg print:hidden ml-4"
                    >
                      Cancel
                    </button> */}
                  </td>
                </>
              ) : (
                <>
                  <td className="  py-0 border-l border-black " align="left">
                    <p className="mx-2">{item.description}</p>
                  </td>
                  <td
                    className=" px-2 py-0 border-l border-black "
                    align="right"
                  >
                    {item.quantity}
                  </td>
                  <td
                    className=" px-2 py-0 border-l border-black "
                    align="right"
                  >
                    {item.rate}
                  </td>
                  <td
                    className=" px-2 py-0 border-x border-black "
                    align="right"
                  >
                    <div className="flex gap-2">
                      <span className="grow">{item.amount}</span>
                      <button
                        onClick={() => handleDeleteItem(index)}
                        className="text-white bg-rose-500 px-2 mb-1 py-1 font-light rounded-lg print:hidden "
                      >
                        <DeleteIcon classes="h-4 w-4" />
                      </button>
                      <button
                        onClick={() => handleEditItem(index)}
                        className="text-white bg-black px-2 mb-1 py-1 font-light rounded-lg print:hidden "
                      >
                        <EditIcon classes="h-4 w-4" />
                      </button>
                    </div>
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
        <tbody>
          <tr>
            <td rowSpan="4" valign="top">
              <div className="">
                <p className="py-1  font-bold">Terms and Conditions : </p>
                <TermsTextArea
                  terms={terms}
                  setTerms={setTerms}
                  termsError={termsError}
                />
              </div>
            </td>
            <td
              colSpan={3}
              className="border  border-black font-bold px-4 py-1"
            >
              <div className="flex justify-between">
                <span>VAT (5.0%) </span>
                <span className="font-light"> AED&nbsp;{calculateVAT()}</span>
              </div>
            </td>
          </tr>
          <tr>
            {/* <td>
            <p className="text-light text-sm px-2 py-0">Emirated Islamic Bank</p>
            </td> */}
            <td colSpan={3} className="border border-black font-bold px-4 py-1">
              <div className="flex justify-between">
                <span>Invoice Total</span>
                <span className="font-light">
                  {' '}
                  AED&nbsp;{calculateInvoiceTotal()}
                </span>
              </div>
            </td>
          </tr>
          <tr className="mt-16">
            {/* <td>
              <p className="text-light text-sm px-2 py-0">Account Name : AL BUSINESS HOUSE BUSINESS SERVICES</p>
              </td> */}
            <td colSpan={3} className="border border-black font-bold px-4 py-1">
              <div className="flex justify-between">
                <span>Payment/Credits</span>
                <span className="font-light flex items-center ">
                  {' '}
                  <span>AED</span>
                  <span className="ml-1 hidden print:block">
                    {paymentCredits === 0 ? '0.0' : paymentCredits}
                  </span>
                  <input
                    type="number"
                    onKeyDown={(event) => {
                      if (
                        event.key === 'e' ||
                        event.key === 'E' ||
                        event.key === '-'
                      ) {
                        event.preventDefault();
                      }
                    }}
                    min={0.1}
                    value={paymentCredits}
                    onChange={(e) => setPaymentCredits(e.target.value)}
                    className="border border-gray-300 px-2 py-1 print:hidden ml-1"
                    placeholder="payment credits"
                  />
                </span>
              </div>
            </td>
          </tr>
          <tr>
            {/* <td></td> */}
            <td colSpan={3} className="border border-black font-bold px-4 py-1">
              <div className="flex justify-between">
                <span>Balance Due</span>
                <span className="font-light"> AED&nbsp;{balanceDue()}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <p className="uppercase text-center mt-12 text-xs">
        This is computer generated quotation, does not require signature and
        stamp
      </p>

      <div className="print:hidden mt-12 flex justify-center">
        <button
          onClick={() => handleSaveData()}
          className="bg-green-500 text-white px-4 py-2 mr-2  "
        >
          {loading ? 'Saving' : 'Save'}
        </button>
        <button
          onClick={handlePrint}
          className="bg-yellow-500 text-white px-4 py-2"
        >
          Print
        </button>
      </div>
      {/* Custom print styles */}
    </div>
  );
};

export default FormTable;
